import React, { useState, useEffect } from "react";

// Wraps any image (or GatsbyImage) so clicking it opens a full-screen
// modal with a larger view. Closes on Escape, clicking the backdrop,
// or the close button. Used for both inline post images and the hero image.
const ImageLightbox = ({ src, alt, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="block w-full h-full p-0 border-0 bg-transparent cursor-zoom-in"
        aria-label={`View larger version of ${alt || "image"}`}
      >
        {children}
      </button>

      {isOpen && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
        <div
          className="fixed inset-0 z-[300] flex items-center justify-center bg-black/85 p-6"
          onClick={(e) => {
            if (e.target === e.currentTarget) setIsOpen(false);
          }}
          role="dialog"
          aria-modal="true"
          aria-label={alt || "Expanded image"}
        >
          <button
            type="button"
            onClick={() => setIsOpen(false)}
            className="absolute top-6 right-6 text-white text-[28px] leading-none w-10 h-10 flex items-center justify-center hover:opacity-70"
            aria-label="Close"
          >
            &times;
          </button>
          <img
            src={src}
            alt={alt || ""}
            className="max-w-full max-h-full object-contain"
          />
        </div>
      )}
    </>
  );
};

export default ImageLightbox;
